import React from "react";
import img from "../../../../groupe_pages/PMT/img/img_v2/SLIDE-US-VINYL.webp";
const Feature = ({ icon, title, text }) => (
  <div className="up-feature">
    <div className="up-feature-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
);

const Title = ({ small, big }) => (
  <div className="up-title">
    <span>{small}</span>
    <h2>{big}</h2>
  </div>
);

export default function UsPrintPage() {
  return (
    <div className="up-page">

      {/* HERO */}
      <section className="up-hero">
        <div className="up-hero-content">
        
        <div className="us-badge" ><h3 ><span className="subtitle-us">US</span> <b>PRINT</b></h3></div>

          <h1>Toile Tendu Imprimée Grand Format</h1>

          <p>
            Transformez vos murs et plafonds en surfaces décoratives
            spectaculaires grâce à l’impression HD sur toile tendue.
            Solution idéale pour le design intérieur, le branding et
            les ambiances immersives.
          </p>

          <div className="up-hero-buttons">
           <a className="btn-primarya" href="/devis">Demander un devis</a>
            <a href="/docs/catalogue-unik-system.pdf"download className="btn-outline">Télécharger la fiche technique</a>
            
          </div>
        </div>

        <div className="up-hero-img">
          <img src={img} alt="US Print toile imprimée" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="up-section">
        <Title
          small="Présentation"
          big="Qu’est-ce que la solution US PRINT ?"
        />

        <div className="up-two-cols">
          <p>
            US PRINT est une solution d’impression haute résolution sur
            toile tendue PVC ou textile. Elle permet de créer des visuels
            grand format intégrés à l’architecture intérieure.
          </p>

          <p>
            Photos, graphismes, textures, logos ou fresques — chaque projet
            devient une signature visuelle unique adaptée aux espaces
            professionnels et résidentiels premium.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="up-section up-gray">
        <Title small="Atouts" big="Avantages clés" />

        <div className="up-grid">
          <Feature icon="🖼️" title="Impact visuel fort" text="Effet décoratif premium immédiat." />
          <Feature icon="🎨" title="Personnalisation totale" text="Visuels sur mesure et branding." />
          <Feature icon="🔎" title="Haute résolution" text="Qualité photo grand format." />
          <Feature icon="💡" title="Compatible lumineux" text="Version rétro-éclairée disponible." />
          <Feature icon="🛠️" title="Remplaçable" text="Changement visuel sans gros travaux." />
          <Feature icon="⚡" title="Pose rapide" text="Installation propre et maîtrisée." />
        </div>
      </section>

      {/* TYPES VISUELS */}
      <section className="up-section">
        <Title small="Design" big="Types de visuels possibles" />

        <div className="up-tags">
          {[
            "Photos HD",
            "Graphisme",
            "Motifs artistiques",
            "Paysages",
            "Textures matière",
            "Logos",
            "Branding",
            "Signalétique",
            "Fresques",
          ].map(t => <span key={t}>{t}</span>)}
        </div>
      </section>

      {/* SUPPORTS */}
      <section className="up-section up-gray">
        <Title small="Supports" big="Toiles compatibles" />

        <ul className="up-list up-wide">
          <li>Toile PVC tendue</li>
          <li>Toile textile polyester</li>
          <li>Toile rétro-éclairable</li>
          <li>Toile translucide</li>
          <li>Toile acoustique imprimée</li>
          <li>Support grand format sans joint (selon dimensions)</li>
        </ul>
      </section>

      {/* LUMINEUX */}
      <section className="up-section">
        <Title small="Option" big="Version impression lumineuse" />

        <div className="up-two-cols">
          <ul className="up-list">
            <li>Plafond imprimé rétro-éclairé</li>
            <li>Mur lumineux décoratif</li>
            <li>Caisson lightbox</li>
            <li>Logo lumineux</li>
          </ul>

          <ul className="up-list">
            <li>Diffusion LED uniforme</li>
            <li>Ambiance immersive</li>
            <li>Signalétique premium</li>
            <li>Visibilité renforcée</li>
          </ul>
        </div>
      </section>

      {/* PROCESS */}
      <section className="up-section up-gray">
        <Title small="Méthode" big="Processus de réalisation" />

        <div className="up-steps">
          {[
            "Choix du visuel",
            "Contrôle résolution",
            "Simulation rendu",
            "Impression HD",
            "Découpe technique",
            "Pose toile tendue",
            "Contrôle final",
          ].map((s, i) => (
            <div key={s} className="up-step">
              <div className="up-step-num">{i + 1}</div>
              <p>{s}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="up-cta">
        <h2>Donnez une signature visuelle à votre espace</h2>
        <p>Création graphique + impression + installation professionnelle.</p><br/>
        <a href="/contact" className="btn-primarya">Contact nos</a>

      </section>

    </div>
  );
}